import { Component, OnInit } from '@angular/core';
import { MatchService } from '../match.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subscription, interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import swal from "sweetalert2";
import { ChatService } from '../chat.service';

@Component({
  selector: 'app-fancy',
  templateUrl: './fancy.component.html',
  styleUrls: ['./fancy.component.css']
})
export class FancyComponent implements OnInit {
  private fancySub: Subscription;
  private autoFancyStatusSub: Subscription;
  private oddsSubO: Subscription;
  private destroyed = new Subject();
  isLoading = false;
  isLoadingO = false;
  isLoadingN = false;
  isLoadingC = false;
  isLoadingS = false;
  isWBTLoading = false;
  id: string;
  marketId: string;
  sportId: string;
  matchData: any;
  matchRunners: any[];
  fancyData: any;
  statusFancy = [];
  statusFancyAuto = [];
  fdata = [];
  data = [];
  afdata = [];
  adata = [];
  oddsData: any;
  oddsCData: any;
  oddsSData: any;
  oddsNData: any;
  interval: any;
  operation = 'All';
  search = false;
  searchValue = '';
  intervalSubscription: any;
  fancyProvider = '';
  fancyTimeout;
  oddsType: string;
  oddsRunners = [];
  manualFancy: any;
  fanciesType = { "1": "normal_fancies", "2": "khado_fancies", "3": "meter_fancies", "4": "fancy_1_fancies", "5": "ball_by_ball_fancies" };
  constructor(private matchService: MatchService, private route: ActivatedRoute, private chatService: ChatService) { }

  ngOnInit() {
    this.isLoading = true;
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      if (paramMap.has('id')) {
        this.id = paramMap.get('id');
        this.matchService.getMatch(this.id).subscribe(response => {
          this.isLoading = false;
          this.matchData = response['result'];
          this.marketId = this.matchData.marketId;
          this.sportId = this.matchData.sportId;
          this.fancyProvider = this.matchData.fancyProvider;

          this.matchRunners = this.matchData.matchRunners;
          //this.matchService.getOddsData(this.matchData.eventId);
          this.chatService.setOdds(this.id);
          this.chatService.getOdds(this.id);
          this.oddsSubO = this.chatService.getUpdateMessageListner().subscribe((resp) => {
            //console.log(resp.message);
            this.oddsType = resp.message['Type'];
            this.oddsRunners = resp.message['matchRunners'];
            if (resp.message['data'].length > 0) {
              if (this.oddsType == 'Neeraj' || this.oddsType == 'Tree' || this.oddsType == 'Ar' || this.oddsType == 'World') {
                this.oddsData = resp.message['data'][0];
                //console.log(this.oddsData);
              }
              else if (this.oddsType == 'Sky' || this.oddsType == 'Diamond') {
                this.oddsData = resp.message['data'];
              }
            }
            else {
              this.oddsData = [];
            }
          });

          if (this.sportId == '4') {
            this.matchService.getFancy(this.id, this.marketId, this.fancyProvider, this.operation);
            this.fancyScheduler();
          }

          this.fancySub = this.matchService.getUpdateFancyListner().subscribe((resp) => {
            if (resp.fancy['result'].data == null) {
              this.afdata = [];
              this.destroyed.next();
              this.fancyTimeout = setTimeout(() => {
                this.fancyScheduler();
              }, 3000);
            }
            else {
              if (this.fancyProvider == 'diamond') {
                let data = JSON.parse(resp.fancy['result'].data);
                let datas = data.data.t3 || [];
                let datas4 = []; //data.data.t4 || [];
                //console.log(datas4);
                this.afdata = [...datas, ...datas4].filter(resp => {
                  return resp?.ballsess != '3'; //&& resp?.ballsess != '2'
                }).sort((a, b) => (a.srno > b.srno) ? 1 : -1);
              }
              else if (this.fancyProvider == 'sky') {
                let datas = JSON.parse(resp.fancy['result'].data);
                this.afdata = datas.filter(resp => {
                  return resp.status != '18' && resp.status != '1' && resp.status != '14';
                });
              }
              else if (this.fancyProvider == 'sk') {
                this.afdata = JSON.parse(resp.fancy['result'].data);
              }
              else if (this.fancyProvider == 'world') {
                let datas = JSON.parse(resp.fancy['result'].data);
                this.afdata = datas;
                //console.log(this.afdata);
              }
              else if (this.fancyProvider == 'bull') {
                const datas = JSON.parse(resp.fancy['result'].data) || {};
                const dt = Object.values(datas).map(dts => (dts['data']));
                this.afdata = Array.prototype.concat.apply([], dt);
                //console.log(datas);
              }
              else if (this.fancyProvider == 'tiger') {
                let data = JSON.parse(resp.fancy['result'].data);
                let datas = data || [];
                this.afdata = datas;
              }
              else {
                let datas = JSON.parse(resp.fancy['result'].data);
                this.afdata = datas;
              }
            }

            this.autoFancyStatusSub = this.matchService.getAutoUpdateFancyStatusListner().subscribe((autoFancy) => {
              this.statusFancyAuto = autoFancy.autoFancyStatus['result'];
              //console.log(this.statusFancyAuto);
              if (this.fancyProvider == 'diamond') {
                if (this.operation == 'All') {
                  //console.log(this.afdata);
                  this.adata = this.NewAutoFancies(this.afdata, this.statusFancyAuto);
                  this.adata = this.NewAutoSearchFancies(this.searchValue);
                  //console.log(this.adata);
                }
                else {
                  let adata2 = this.OtherAutoFancies(this.afdata, this.statusFancyAuto);
                  let NR = this.OtherAutoFancies2(this.statusFancyAuto, adata2);
                  const mappedN = NR.map(e => {
                    e = {
                      ...e,
                      'sid': e.runnerId,
                      'nat': e.name,
                      'ls1': 0,
                      'bs1': 0,
                      'l1': 0,
                      'b1': 0,
                      'gstatus': 'SUSPENDED',
                      'gtype': 'NA'
                    };
                    return e;
                  });
                  //console.log(mappedN);
                  this.adata = [...adata2, ...mappedN];
                  this.adata = this.NewAutoSearchFancies(this.searchValue);
                }
              }
              else if (this.fancyProvider == 'sky') {
                if (this.operation == 'All') {
                  this.adata = this.NewAutoSkyFancies(this.afdata, this.statusFancyAuto);
                  this.adata = this.NewAutoSearchSkyFancies(this.searchValue);
                }
                else {
                  let adata2 = this.OtherAutoSkyFancies(this.afdata, this.statusFancyAuto);
                  let NR = this.OtherAutoSkyFancies2(this.statusFancyAuto, adata2);
                  const mappedN = NR.map(e => {
                    e = {
                      ...e,
                      'marketId': e.runnerId,
                      'marketName': e.name,
                      'oddsYes': 0,
                      'oddsNo': 0,
                      'runsYes': 0,
                      'runsNo': 0,
                      'status': '6'
                    };
                    return e;
                  });
                  //console.log(mappedN);
                  this.adata = [...adata2, ...mappedN];
                  this.adata = this.NewAutoSearchSkyFancies(this.searchValue);
                }
              }
              else if (this.fancyProvider == 'sk') {
                if (this.operation == 'All') {
                  this.adata = this.NewAutoSkFancies(this.afdata, this.statusFancyAuto);
                  this.adata = this.NewAutoSearchSkFancies(this.searchValue);
                }
                else {
                  let adata2 = this.OtherAutoSkFancies(this.afdata, this.statusFancyAuto);
                  let NR = this.OtherAutoSkFancies2(this.statusFancyAuto, adata2);
                  const mappedN = NR.map(e => {
                    e = {
                      ...e,
                      'sky_fancy_id': e.runnerId,
                      'runner_name': e.name,
                      'yes_odd': 0,
                      'no_odd': 0,
                      'yes_bhav': 0,
                      'no_bhav': 0,
                      'is_sus': 1
                    };
                    return e;
                  });
                  //console.log(mappedN);
                  this.adata = [...adata2, ...mappedN];
                  this.adata = this.NewAutoSearchSkFancies(this.searchValue);
                  //console.log(this.adata);
                }
              }
              else if (this.fancyProvider == 'neeraj') {
                if (this.operation == 'All') {
                  this.adata = this.NewAutoNeerajFancies(this.afdata, this.statusFancyAuto);
                  this.adata = this.NewAutoSearchNeerajFancies(this.searchValue);
                }
                else {
                  let adata2 = this.OtherAutoNeerajFancies(this.afdata, this.statusFancyAuto);
                  let NR = this.OtherAutoNeerajFancies2(this.statusFancyAuto, adata2);
                  const mappedN = NR.map(e => {
                    e = {
                      ...e,
                      'SelectionId': e.runnerId,
                      'RunnerName': e.name,
                      'LayPrice1': 0,
                      'BackPrice1': 0,
                      'LaySize1': 0,
                      'BackSize1': 0,
                      'GameStatus': 'SUSPENDED'
                    };
                    return e;
                  });
                  //console.log(mappedN);
                  this.adata = [...adata2, ...mappedN];
                  this.adata = this.NewAutoSearchNeerajFancies(this.searchValue);
                }
              }
              else if (this.fancyProvider == 'world') {
                if (this.operation == 'All') {
                  //console.log(this.afdata);
                  this.adata = this.NewAutoFancies(this.afdata, this.statusFancyAuto);
                  this.adata = this.NewAutoSearchFancies(this.searchValue);
                  //console.log(this.adata);
                }
                else {
                  let adata2 = this.OtherAutoFancies(this.afdata, this.statusFancyAuto);
                  let NR = this.OtherAutoFancies2(this.statusFancyAuto, adata2);
                  const mappedN = NR.map(e => {
                    e = {
                      ...e,
                      'sid': e.runnerId,
                      'nat': e.name,
                      'ls1': 0,
                      'bs1': 0,
                      'l1': 0,
                      'b1': 0,
                      'gstatus': 'SUSPENDED'
                    };
                    return e;
                  });
                  // console.log(mappedN);
                  this.adata = [...adata2, ...mappedN];
                  this.adata = this.NewAutoSearchFancies(this.searchValue);
                }
              }
              else if (this.fancyProvider == 'bull') {
                if (this.operation == 'All') {
                  this.adata = this.NewAutoBullFancies(this.afdata, this.statusFancyAuto);
                  this.adata = this.NewAutoSearchBullFancies(this.searchValue);
                }
                else {
                  let adata2 = this.OtherAutoBullFancies(this.afdata, this.statusFancyAuto);
                  let NR = this.OtherAutoBullFancies2(this.statusFancyAuto, adata2);
                  const mappedN = NR.map(e => {
                    e = {
                      ...e,
                      'id': e.runnerId,
                      'runner_name': e.name,
                      'yes_bhav': 0,
                      'no_bhav': 0,
                      'yes_odd': 0,
                      'no_odd': 0,
                      'is_sus': true,
                      'fancy_market_id': '-1'
                    };
                    return e;
                  });
                  //console.log(mappedN);
                  this.adata = [...adata2, ...mappedN];
                  this.adata = this.NewAutoSearchBullFancies(this.searchValue);
                }
              }
              else if (this.fancyProvider == 'tiger') {
                if (this.operation == 'All') {
                  this.adata = this.NewAutoTigerFancies(this.afdata, this.statusFancyAuto);
                  this.adata = this.NewAutoSearchTigerFancies(this.searchValue);
                }
                else {
                  let adata2 = this.OtherAutoTigerFancies(this.afdata, this.statusFancyAuto);
                  //console.log(adata2);
                  let NR = this.OtherAutoTigerFancies2(this.statusFancyAuto, adata2);
                  const mappedN = NR.map(e => {
                    e = {
                      ...e,
                      'id': e.runnerId,
                      'name': e.name,
                      'ls1': 0,
                      'bs1': 0,
                      'l1': 0,
                      'b1': 0,
                      'status1': 'SUSPENDED'
                    };
                    return e;
                  });

                  this.adata = [...adata2, ...mappedN];
                  this.adata = this.NewAutoSearchTigerFancies(this.searchValue);
                }
              }
            });
          });
        }), () => {
          this.isLoading = false;
        };
      }
    });
  }

  fancyScheduler() {
    interval(1000).pipe(takeUntil(this.destroyed)).subscribe(() => {
      this.matchService.getFancy(this.id, this.marketId, this.fancyProvider, this.operation);
    });
  }

  setFancyStatus(status, eventId, selectionId, name, runnerId, provider, data) {
    let marketId = selectionId;
    // if (this.matchData.fancyProvider == 'Alwa') {
    //   selectionId = this.hashCode(selectionId);
    // }

    //console.log(this.matchData.fancyProvider);
    this.matchService.setFancyStatus(status, eventId, selectionId, name, provider, marketId, runnerId, data)
      .subscribe((response) => {
        //console.log(response);
        this.msgSuccess();
      });
  }

  getFancyByStatus(status, id) {
    let btn = document.getElementById(id);
    let btnall = document.getElementById('all');
    let btnin = document.getElementById('inactive');
    let btna = document.getElementById('active');
    let btnc = document.getElementById('close');
    let btnr = document.getElementById('remove');
    btnall.classList.add("btn-primary");
    btnin.classList.add("btn-primary");
    btna.classList.add("btn-primary");
    btnc.classList.add("btn-primary");
    btnr.classList.add("btn-primary");

    btnall.classList.remove("btn-success");
    btnin.classList.remove("btn-success");
    btna.classList.remove("btn-success");
    btnc.classList.remove("btn-success");
    btnr.classList.remove("btn-success");
    btn.classList.add("btn-success");
    //console.log(btn);
    this.destroyed.next();
    this.operation = status;
    this.fancyScheduler();
  }

  searchFancy(e) {
    //this.destroyed.next();
    this.search = true;
    this.searchValue = e.target.value;
    //this.fancyScheduler();
  }

  // validData(myArr, value) {
  //   return myArr.filter((listing: any) => listing.name != value);
  // }

  NewAutoFancies(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.sid) === selectionId
      }));
  }

  NewAutoSkyFancies(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.marketId) === selectionId
      }));
  }

  NewAutoSkFancies(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.sky_fancy_id) === selectionId
      }));
  }

  NewAutoBullFancies(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.id) === selectionId
      }));
  }

  NewAutoNeerajFancies(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.SelectionId) === selectionId
      }));
  }

  NewAutoSearchFancies(search) {
    return this.adata.filter(o => {
      return o.nat.toLowerCase().includes(search.toLowerCase())
    });
  }

  NewAutoSearchSkyFancies(search) {
    return this.adata.filter(o => {
      return o.marketName.toLowerCase().includes(search.toLowerCase())
    });
  }

  NewAutoSearchSkFancies(search) {
    return this.adata.filter(o => {
      return o.runner_name.toLowerCase().includes(search.toLowerCase())
    });
  }

  NewAutoSearchBullFancies(search) {
    return this.adata.filter(o => {
      return o.runner_name.toLowerCase().includes(search.toLowerCase())
    });
  }

  NewAutoSearchNeerajFancies(search) {
    return this.adata.filter(o => {
      return o.RunnerName.toLowerCase().includes(search.toLowerCase())
    });
  }

  OtherAutoFancies(array1, array2) {
    return array1.filter(o => array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.sid) === selectionId
      }));
  }

  OtherAutoSkyFancies(array1, array2) {
    return array1.filter(o => array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.marketId) === selectionId
      }));
  }

  OtherAutoSkFancies(array1, array2) {
    return array1.filter(o => array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.sky_fancy_id) === selectionId
      }));
  }

  OtherAutoBullFancies(array1, array2) {
    return array1.filter(o => array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.id) === selectionId
      }));
  }

  OtherAutoNeerajFancies(array1, array2) {
    return array1.filter(o => array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.SelectionId) === selectionId
      }));
  }

  OtherAutoFancies2(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ sid }) => {
        return this.makeFancy(sid) === o.selectionId
      }));
  }

  OtherAutoSkyFancies2(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ marketId }) => {
        return this.makeFancy(marketId) === o.selectionId
      }));
  }

  OtherAutoSkFancies2(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ sky_fancy_id }) => {
        return this.makeFancy(sky_fancy_id) === o.selectionId
      }));
  }

  OtherAutoBullFancies2(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ id }) => {
        return this.makeFancy(id) === o.selectionId
      }));
  }

  OtherAutoNeerajFancies2(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ SelectionId }) => {
        return this.makeFancy(SelectionId) === o.selectionId
      }));
  }

  NewAutoTigerFancies(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.id) === selectionId
      }));
  }

  NewAutoSearchTigerFancies(search) {
    return this.adata.filter(o => {
      return o.name.toLowerCase().includes(search.toLowerCase())
    });
  }

  OtherAutoTigerFancies2(array1, array2) {
    return array1.filter(o => !array2.some(
      ({ id }) => {
        return this.makeFancy(id) === o.selectionId
      }));
  }

  OtherAutoTigerFancies(array1, array2) {
    return array1.filter(o => array2.some(
      ({ selectionId }) => {
        return this.makeFancy(o.id) === selectionId
      }));
  }

  selectionName(name) {
    return this.oddsRunners.filter(o => {
      return o.selectionId == name
    });
  }

  updateOdds(eventId) {
    var odds = document.getElementById('odds') as HTMLSelectElement;
    let data = { "oddsProvider": odds.value, "eventId": eventId };
    this.matchService.updateMatchOdds(data).subscribe((response) => {
      this.msgSuccess();
      //console.log(response);
    });
  }

  makeFancy(sid) {
    return this.id + '-' + sid + '.FY';
  }

  hashCode(s) {
    for (var i = 0, h = 0; i < s.length; i++)
      h = Math.imul(31, h) + s.charCodeAt(i) | 0;
    if (h < 0) {
      return (-1 * h);
    }
    return h;
  }

  fcType(value) {
    return this.fanciesType[value];
  }

  closePopup(status, eventId, fancyid, selectionId, name) {
    //console.log(status, eventId, fancyid, selectionId, name);
    let selection = fancyid;
    // if (marketid && this.matchData.fancyProvider == 'Alwa') {
    //   selection = this.hashCode(marketid);
    // }
    // else if (marketid && this.matchData.fancyProvider != 'Alwa') {
    //   selection = marketid;
    // }
    // else {
    //   selection = selectionId;
    // }
    // if (fancyid != '') {
    //   selection = fancyid;
    // }
    // else {

    // }

    swal.fire({
      title: 'Enter Winning Runs',
      html: name + '<br> <input type="number" id="result" placeholder="Enter Runs" class="form-control">',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        //console.log(result.value);
        this.setResult(eventId, selection, name);
      }
    })
  }

  setResult(eventId, selection, name) {
    const input = (<HTMLInputElement>document.getElementById("result")).value;
    this.matchService.setResult(parseInt(input), eventId, selection, name).subscribe((response) => {
      //console.log(response);
    });
  }

  insertAllFancy(status, fancy) {
    let nFancy = [];
    let nFancyLogs = [];
    if (this.fancyProvider == 'diamond') {
      nFancy = fancy.map(data => ({ eventId: this.matchData.eventId, selectionId: this.matchData.eventId + '-' + data.sid + '.FY', name: data.nat, runnerId: data.sid, status: status, provider: this.fancyProvider }));
      nFancyLogs = fancy.map(data => ({ eventId: this.matchData.eventId, selectionId: this.matchData.eventId + '-' + data.sid + '.FY', result: data.nat, type1: 'Fancy', value: status, type2: this.fancyProvider }));
    }
    else if (this.fancyProvider == 'sky') {
      nFancy = fancy.map(data => ({ eventId: this.matchData.eventId, selectionId: this.matchData.eventId + '-' + data.marketId + '.FY', name: data.marketName, runnerId: data.marketId, status: status, provider: this.fancyProvider }));
      nFancyLogs = fancy.map(data => ({ eventId: this.matchData.eventId, selectionId: this.matchData.eventId + '-' + data.marketId + '.FY', result: data.marketName, type1: 'Fancy', value: status, type2: this.fancyProvider }));
    }
    else if (this.fancyProvider == 'neeraj') {
      nFancy = fancy.map(data => ({ eventId: this.matchData.eventId, selectionId: this.matchData.eventId + '-' + data.SelectionId + '.FY', name: data.RunnerName, runnerId: data.SelectionId, status: status, provider: this.fancyProvider }));
      nFancyLogs = fancy.map(data => ({ eventId: this.matchData.eventId, selectionId: this.matchData.eventId + '-' + data.SelectionId + '.FY', result: data.RunnerName, type1: 'Fancy', value: status, type2: this.fancyProvider }));
    }

    this.matchService.insertAllFancy(nFancy, nFancyLogs, this.matchData.eventId)
      .subscribe((res) => {
        //console.log(res);
        this.msgSuccess();
      });
  }

  updateAllFancy(status) {
    //console.log(status);
    this.matchService.updateAllFancy(status, this.matchData.eventId)
      .subscribe((res) => {
        //console.log(res);
        this.msgSuccess();
      });
  }

  rollbackPopup(eventId, fancyid) {
    swal.fire({
      title: 'Are you sure want to rollback this result ?',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        //console.log(result.value);
        this.rollbackResult(eventId, fancyid);
      }
    })
  }

  rollbackResult(eventId, selection) {
    this.matchService.setResultRollback(eventId, selection).subscribe((response) => {
      //console.log(response);
    });
  }

  msgSuccess() {
    swal.fire({
      icon: 'success',
      title: 'Successfully Update!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  msgFailure() {
    swal.fire({
      icon: 'error',
      title: 'Something Went Wrong!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  ngOnDestroy() {
    this.chatService.destorySocket(this.id);
    if (this.autoFancyStatusSub) {
      this.autoFancyStatusSub.unsubscribe();
    }

    if (this.fancySub) {
      this.fancySub.unsubscribe();
    }

    if (this.oddsSubO) {
      this.oddsSubO.unsubscribe();
    }

    clearTimeout(this.fancyTimeout);
    this.destroyed.next();
  }
}